import {
  faArrowRight,
  faChartLine,
  faCoins,
  faLeaf,
  faStore,
  faThLarge,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import currencyConverter from "../Assets/currency-conveter.png";
import energyUsageCalculator from "../Assets/energy-usage-calculator.png";
import smartSme from "../Assets/smart-sme.png";
import portfolioHero from "../Assets/heroes/portfolio-hero.webp";
import React from "react";
import { Link } from "react-router-dom";
import PrimaryHero from "../Components/PrimaryHero";
import SectionHeading from "../Components/SectionHeading";

const portfolioItems = [
  {
    image: smartSme,
    icon: faStore,
    title: "Smart SME",
    label: "Business management",
    copy: "A practical mobile app for small business owners to manage finances, inventory, and customer relationships in one place.",
    outcome: "Helps small business owners manage their business in one place.",
    href: "https://play.google.com/store/apps/details?id=africa.milesoft.smartsme&pcampaignid=web_share",
  },
  {
    image: currencyConverter,
    icon: faCoins,
    title: "Currency Converter",
    label: "Everyday finance",
    copy: "A simple Android app for checking currency values quickly, using a clear flow that keeps conversion easy to understand.",
    outcome: "Helps users compare money values without extra steps.",
    href: "https://play.google.com/store/apps/details?id=co.milesoft.currencyconverter&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
  },
  {
    image: energyUsageCalculator,
    icon: faLeaf,
    title: "Energy Usage Calculator",
    label: "Home insight",
    copy: "A practical mobile tool for estimating energy use and making more informed choices about everyday consumption.",
    outcome: "Helps users understand usage before it becomes a surprise.",
    href: "https://play.google.com/store/apps/details?id=co.milesoft.energyusagecalculator&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1",
  },
];

function Portfolio() {
  return (
    <div className="primary-page">
      <PrimaryHero
        titleId="portfolio-title"
        icon={faThLarge}
        kicker="Portfolio"
        title="Useful products with simple outcomes."
        description={
          <p>
              Our portfolio shows how MileSoft turns focused needs into
              practical apps that help people calculate, compare, decide, and
              act.
          </p>
        }
        imageSrc={portfolioHero}
        actions={
          <>
              <Link to="/contacts" className="btn-ms btn-ms-primary btn-ms-lg">
                Discuss a product
                <FontAwesomeIcon icon={faArrowRight} aria-hidden="true" />
              </Link>
              <Link
                to="/projects"
                className="btn-ms btn-ms-secondary btn-ms-lg"
              >
                View projects
              </Link>
          </>
        }
      />

      <section
        className="section-ms section-ms-soft"
        aria-labelledby="portfolio-work-title"
      >
        <div className="section-ms-inner">
          <SectionHeading
            titleId="portfolio-work-title"
            kicker="Selected work"
            title="Built around clear user tasks"
            description={
              <p>
              Each product is framed by the job it helps someone complete, not
              by extra decoration or unnecessary feature lists.
              </p>
            }
          />
          <div className="portfolio-grid">
            {portfolioItems.map((item) => (
              <article className="card-ms portfolio-card" key={item.title}>
                <div className="card-ms-body">
                  <div className="primary-card-meta">
                    <span className="brand-icon" aria-hidden="true">
                      <FontAwesomeIcon icon={item.icon} />
                    </span>
                    <span className="badge-ms">{item.label}</span>
                  </div>
                  <div className="portfolio-card-media">
                    <img src={item.image} alt={`${item.title} app icon`} />
                  </div>
                  <h3>{item.title}</h3>
                  <p>{item.copy}</p>
                  <p className="portfolio-outcome">
                    <FontAwesomeIcon icon={faChartLine} aria-hidden="true" />
                    {item.outcome}
                  </p>
                  <a
                    className="btn-ms btn-ms-secondary btn-ms-md"
                    href={item.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={`Open ${item.title} on Google Play`}
                  >
                    View on Google Play
                  </a>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Portfolio;
